import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { AppContext } from 'src/app/modules/appContext/AppContext';
import { TimeEditor } from 'src/app/modules/component/time-editor/TimeEditor';
import { useTimeEditorManager } from 'src/app/modules/component/time-editor/useTimeEditorManager';
import { updateOrderGroupFields } from 'src/app/modules/phan-he-kham-benh/services/ChiDinhDVService';
import { hasAuthority, KEY_AUTHORITIES } from 'src/app/modules/utils/Permission';
import ButtonIn from '../../../../component/button-in-phieu';
import { ConfirmDialog } from '../../../../component/ConfirmDialog';
import DanhSachPhieu from '../../../../component/DanhSachPhieu';
import InputSearch from '../../../../component/InputSearch';
import LabelRequired from '../../../../component/LabelRequired';
import { TableCustom } from '../../../../component/table/table-custom/TableCustom';
import { columnsDanhSachDonThuoc } from '../../../../phan-he-kham-benh/columns/tab-thuoc/ColumnTabThuoc';
import { WORKFLOW_MEDICAL_ITEM_STATUS_CODE } from '../../../../phan-he-kham-benh/constants/Thuoc';
import { IInPhieuChiDinhThuocParams } from '../../../../phan-he-kham-benh/models/ThuocModels';
import { deleteDonThuoc, huyGuiDonThuoc, printPhieuChiDinhThuoc } from '../../../../phan-he-kham-benh/services/ThuocService';
import FormChiDinhThuoc from '../../../../phan-he-noi-tru-dieu-tri/components/chi-dinh-thuoc';
import { getThongTinPhieuThuoc, updateKeThuoc } from '../../../../phan-he-noi-tru-dieu-tri/services/DieuTriServices';
import { APP_DATE_TIME_FORMAT, CODE, KEY, KEY_DS_DANH_MUC_TIEP_DON, ORDER_TYPE_ID, REQUEST_FROM, REQUEST_TYPE, RESPONSE_MESSAGE } from '../../../../utils/Constant';
import { formatDateTime, getErrorMessage } from '../../../../utils/FormatUtils';
import WfButton from '../../../../workflows/components/WfButton';
import { WfConstTrackerClinical } from '../../../../workflows/Constant';
import { usePhanHeNoiTruContext } from '../../../PhanHeNoiTruContext';
import { getDsPhieuThuocVatTu } from '../../../services/HanhChinhServices';
import { ModalChonNgay } from '../../../../phan-he-kham-benh/modals/modal-ke-thuoc/components/NgayKeTuDong';
import { cloneMedicalItem } from '../../../services/Common';
import { SelectEditor, useSelectEditorManager } from 'src/app/modules/component/select-editor';
import { seachUserMetadata } from 'src/app/modules/auth/core/_requests';
import useIndexDBValue from 'src/app/hook/useIndexDBValue';
import { IDanhSachDanhMuc } from 'src/app/modules/phan-he-tiep-nhan-thanh-toan/models/TiepDonModel';

type Props = {
  treatmentSheetId?: string
  allowOrder?: boolean
}

const Thuoc = ({ treatmentSheetId, allowOrder = true }: Props) => {
  const { setIsLoading } = useContext(AppContext);
  const { benhNhanHanhChinh, statusChangedEvent, statusChangedEventFunc } = usePhanHeNoiTruContext();
  const [dsPhieu, setDsPhieu] = useState<any[]>([]);
  const [selectedPhieu, setSelectedPhieu] = useState<any>(null);
  const [donThuocInfo, setDonThuocInfo] = useState<any>(null);
  const [selectedPhieuForClone, setSelectedPhieuForClone] = useState<any>(null);
  const [openModalTachPhieu, setOpenModalTachPhieu] = useState(false);
	const [validateMessage, setValidateMessage] = useState<string>('');
  const [shouldOpenConfirmDialog, setShouldOpenConfirmDialog] = useState<boolean>(false);

  const allowEdit = !benhNhanHanhChinh?.concluded && hasAuthority(KEY_AUTHORITIES.UPDATE_FIELDS.PHIEU_CHI_DINH);

  const { value: danhSachDanhMuc } = useIndexDBValue<IDanhSachDanhMuc>({
    key: KEY_DS_DANH_MUC_TIEP_DON,
  });

  const onUpdate = (updatedData: any, field: string) => {
    if (!updatedData?.[field]) return;
    // Cập nhật selectedPhieu với data mới
    setDonThuocInfo((prev: any) => ({
      ...prev,
      [field]: updatedData[field]
    }));

    // Cập nhật trong danh sách phiếu
    setDsPhieu((prevList: any[]) =>
      prevList.map((phieu: any) =>
        phieu.id === donThuocInfo?.id
          ? { ...phieu, [field]: updatedData[field] }
          : phieu
      )
    );
  }

  const doctorOrderDayManager = useTimeEditorManager({
    name: "doctorOrderDay",
    idFieldName: "orderGroupId",
    values: donThuocInfo,
    updateFields: updateOrderGroupFields,
    onUpdateSuccess: (updatedData) => onUpdate(updatedData, "doctorOrderDay"),
  });

  const designatedDateManager = useTimeEditorManager({
    name: "designatedDate",
    idFieldName: "orderGroupId",
    values: donThuocInfo,
    updateFields: updateOrderGroupFields,
    onUpdateSuccess: (updatedData) => onUpdate(updatedData, "designatedDate"),
  });

  const indicationPersonSelectManager = useSelectEditorManager({
    name: "designatedPerson",
    idFieldName: "orderGroupId",
    values: donThuocInfo,
    updateFields: updateOrderGroupFields,
    buildPayload: (option) => ({
      designatedPerson: option?.fullName,
      indicationTime: donThuocInfo?.designatedDate
    }),
    onUpdateSuccess: (updatedData) => onUpdate(updatedData, "designatedPerson"),
    enableConfirmWithReason: false, // Không dùng confirm with reason cho trường hình thức
  });

  const designatedPlaceSelectManager = useSelectEditorManager({
    name: "designatedPlace",
    idFieldName: "orderGroupId",
    values: donThuocInfo,
    updateFields: updateOrderGroupFields,
    buildPayload: (option) => ({
      requestDeptCode: option?.code,
      requestDeptName: option?.name,
      designatedPlace: option?.name,
      indicationTime: donThuocInfo?.designatedDate
    }),
    onUpdateSuccess: (updatedData) => onUpdate(updatedData, "designatedPlace"),
    enableConfirmWithReason: false, // Không dùng confirm with reason cho trường hình thức
  });

  const handleGetDsPhieu = async () => {
    try {
      let { data } = await getDsPhieuThuocVatTu(benhNhanHanhChinh?.treatmentId, ORDER_TYPE_ID.THUOC, treatmentSheetId);
      if (CODE.SUCCESS === data?.code) {
        let dsPhieuConverted = data?.data?.map((item: any) => {
          return {
            ...item,
            date: moment(item?.doctorOrderDay).format("DD/MM/YYYY"),
          };
        });
        setDsPhieu(dsPhieuConverted || []);
        setSelectedPhieu(null);
      } else {
        setDsPhieu([]);
      }
    } catch (error) {
      console.error(error);
    }
  }

  const handleSelectPhieu = async (id: any) => {
    try {
      let { data } = await getThongTinPhieuThuoc({ medicalItemGroupId: id });
      if (CODE.SUCCESS === data?.code) {
        setDonThuocInfo(data?.data);
      } else {
        setDsPhieu([]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (selectedPhieu?.id) {
      handleSelectPhieu(selectedPhieu?.id);
    } else {
      setDonThuocInfo(null);
    }
  }, [selectedPhieu]);

  useEffect(() => {
    benhNhanHanhChinh?.treatmentId && handleGetDsPhieu();
  }, [benhNhanHanhChinh?.treatmentId, statusChangedEvent, treatmentSheetId]);

  const handleClickClonePhieu = (phieu: any) => {
    setSelectedPhieuForClone(phieu);
    setOpenModalTachPhieu(true);
  };

  const handleSaveTachPhieu = async (selectedDates: any[]) => {
    if (!selectedDates || selectedDates.length === 0) {
      toast.warning('Vui lòng chọn ít nhất một ngày để sao phiếu');
      return;
    }

    if (!selectedPhieuForClone?.id) {
      toast.error('Không tìm thấy thông tin phiếu chỉ định');
      return;
    }

    if (!benhNhanHanhChinh?.treatmentId) {
      toast.error('Không tìm thấy thông tin đợt điều trị');
      return;
    }

    try {
      setIsLoading(true);
      const payload = {
        medicalItemGroupId: selectedPhieuForClone.id,
        treatmentId: benhNhanHanhChinh.treatmentId,
        autoPrescriptions: selectedDates.map(date => ({
          prescriptionDate: date.value,
          treatmentSheetId: date.treatmentSheetId || ""
        }))
      };

      const { data } = await cloneMedicalItem(payload);

      if (data?.code === CODE.SUCCESS) {
        toast.success('Sao phiếu thành công');
        setOpenModalTachPhieu(false);
        setSelectedPhieuForClone(null);
        statusChangedEventFunc?.();
        handleGetDsPhieu();
      } else {
        let errorMessage = getErrorMessage(data);
        setValidateMessage(errorMessage);
        setShouldOpenConfirmDialog(true);
      }
    } catch (error) {
      console.error(error);
      toast.error('Xảy ra lỗi khi sao phiếu');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Row className="h-100 spaces px-16 py-5">
      <div>
        <div className="spaces h-133 px-10 py-4 bg-white border-bottom border-bottom-2 d-flex">
          <Row className='mx-0'>
            <Col xs={4} className="d-flex align-items-center text-lable-input mb-3">
              <LabelRequired label="Loại phiếu:" className="spaces min-w-110" />
              <span className="fw-light text-truncate">
                {donThuocInfo?.type || (donThuocInfo?.id && 'Phiếu chỉ định') || '...'}
              </span>
            </Col>
            <Col xs={4} className="d-flex align-items-center text-lable-input mb-3">
              <LabelRequired label="Ngày y lệnh:" className="spaces min-w-110" />
              <TimeEditor
                name="doctorOrderDay"
                values={donThuocInfo}
                isEditingTime={doctorOrderDayManager.isEditingTime}
                editedTime={doctorOrderDayManager.editedTime}
                showValidationConfirm={doctorOrderDayManager.showValidationConfirm}
                validationMessage={doctorOrderDayManager.validationMessage}
                onEdit={doctorOrderDayManager.handleEditTime}
                onCancel={doctorOrderDayManager.handleCancelEdit}
                onSave={doctorOrderDayManager.handleSaveTime}
                onConfirmValidation={doctorOrderDayManager.handleConfirmValidation}
                onCancelValidation={doctorOrderDayManager.handleCancelValidation}
                onTimeChange={doctorOrderDayManager.setEditedTime}
                allowEdit={allowEdit}
              />
            </Col>
            <Col xs={4} className="d-flex align-items-center text-lable-input mb-3">
              <LabelRequired label="Ngày chỉ định:" className="spaces min-w-110" />
              <TimeEditor
                name="designatedDate"
                values={donThuocInfo}
                isEditingTime={designatedDateManager.isEditingTime}
                editedTime={designatedDateManager.editedTime}
                showValidationConfirm={designatedDateManager.showValidationConfirm}
                validationMessage={designatedDateManager.validationMessage}
                onEdit={designatedDateManager.handleEditTime}
                onCancel={designatedDateManager.handleCancelEdit}
                onSave={designatedDateManager.handleSaveTime}
                onConfirmValidation={designatedDateManager.handleConfirmValidation}
                onCancelValidation={designatedDateManager.handleCancelValidation}
                onTimeChange={designatedDateManager.setEditedTime}
                allowEdit={allowEdit}
              />
            </Col>
            <Col xs={4} className="d-flex align-items-center text-lable-input mb-3">
              <LabelRequired label="Mã phiếu:" className="spaces min-w-110" />
              <span className="fw-light text-truncate">{donThuocInfo?.code || '...'}</span>
            </Col>
            <Col xs={8} className="d-flex align-items-center text-lable-input mb-3">
              <LabelRequired label="Nơi chỉ định:" className="spaces min-w-110" />
              <SelectEditor
                name="designatedPlace"
                values={{
                  designatedPlace: donThuocInfo?.designatedPlace
                }}
                options={danhSachDanhMuc?.listPhongKham || []}
                inline={true}
                menuPlacement="top"
                isEditingSelect={designatedPlaceSelectManager.isEditingSelect}
                editedValue={designatedPlaceSelectManager.editedValue}
                showValidationConfirm={designatedPlaceSelectManager.showValidationConfirm}
                showConfirmWithReason={designatedPlaceSelectManager.showConfirmWithReason}
                validationMessage={designatedPlaceSelectManager.validationMessage}
                onEdit={designatedPlaceSelectManager.handleEditSelect}
                onCancel={designatedPlaceSelectManager.handleCancelEdit}
                onSave={designatedPlaceSelectManager.handleSaveSelect}
                onConfirmValidation={designatedPlaceSelectManager.handleConfirmValidation}
                onCancelValidation={designatedPlaceSelectManager.handleCancelValidation}
                onConfirmWithReason={designatedPlaceSelectManager.handleConfirmWithReason}
                onCancelWithReason={designatedPlaceSelectManager.handleCancelWithReason}
                onValueChange={designatedPlaceSelectManager.setEditedValue}
                allowEdit={allowEdit}
              />
            </Col>
            <Col xs={4} className="d-flex align-items-center text-lable-input mb-3">
              <LabelRequired label="Người chỉ định:" className="spaces min-w-110" />
              <SelectEditor
                name="designatedPerson"
                values={{
                  designatedPerson: donThuocInfo?.designatedPerson
                }}
                options={[]}
                searchFunction={seachUserMetadata}
                searchObject={{ position: 1 }}
                urlData="data.content"
                getOptionLabel={(opt) => opt?.fullName || ""}
                inline={true}
                menuPlacement="top"
                isEditingSelect={indicationPersonSelectManager.isEditingSelect}
                editedValue={indicationPersonSelectManager.editedValue}
                showValidationConfirm={indicationPersonSelectManager.showValidationConfirm}
                showConfirmWithReason={indicationPersonSelectManager.showConfirmWithReason}
                validationMessage={indicationPersonSelectManager.validationMessage}
                onEdit={indicationPersonSelectManager.handleEditSelect}
                onCancel={indicationPersonSelectManager.handleCancelEdit}
                onSave={indicationPersonSelectManager.handleSaveSelect}
                onConfirmValidation={indicationPersonSelectManager.handleConfirmValidation}
                onCancelValidation={indicationPersonSelectManager.handleCancelValidation}
                onConfirmWithReason={indicationPersonSelectManager.handleConfirmWithReason}
                onCancelWithReason={indicationPersonSelectManager.handleCancelWithReason}
                onValueChange={indicationPersonSelectManager.setEditedValue}
                allowEdit={allowEdit}
              />
            </Col>
            <Col xs={8} className="d-flex align-items-center text-lable-input mb-3">
              <LabelRequired label="Trạng thái:" className="spaces min-w-110" />
              <span className="fw-light text-truncate">
                {donThuocInfo?.statusName || '...'}
              </span>
            </Col>
            <Col xs={4} className="d-flex align-items-center text-lable-input mb-3">
              <LabelRequired label="Kho:" className="spaces min-w-110" />
              <span className="fw-light text-truncate">
                {donThuocInfo?.warehouseName || '...'}
              </span>
            </Col>
            <Col xs={8} className="d-flex align-items-center text-lable-input mb-3">
              <LabelRequired label="Chẩn đoán:" className="spaces min-w-110" />
              <span className="fw-light text-truncate">
                {donThuocInfo?.provisionalDiagnosisName || '...'}
              </span>
            </Col>
          </Row>
        </div>
        <div className="px-10 py-5 spaces mb-4">
          <InputSearch
            value={""}
            placeholder="Tìm kiếm"
            handleChange={() => { }}
            className="spaces h-25 radius-3"
          />
        </div>
        <div className="px-7 spaces pb-4">
          <DanhSachPhieu
            dsPhieu={dsPhieu || []}
            handleSelectRowData={(data) => setSelectedPhieu(data)}
            title="price"
            isGetFirstData
            additionalActions={[
              {
                iconClassName: "fa fa-clone",
                tooltip: "Sao phiếu",
                onClick: handleClickClonePhieu 
              }
            ]}
          />
        </div>
        <TableCustom<any>
          className="overflow-auto spaces h-calc-vh-425"
          data={donThuocInfo?.lstMedicalItemOrderRes || []}
          columns={columnsDanhSachDonThuoc}
        />
        <ThaoTacDonThuoc donThuocInfo={donThuocInfo} getDanhSachDonThuoc={handleGetDsPhieu} handleSelectPhieu={handleSelectPhieu} allowOrder={allowOrder} />

        {openModalTachPhieu && (
          <ModalChonNgay
            open={openModalTachPhieu}
            onClose={() => {
              setOpenModalTachPhieu(false);
              setSelectedPhieuForClone(null);
            }}
            onSave={handleSaveTachPhieu}
            treatmentId={benhNhanHanhChinh?.treatmentId}
          />
        )}

        {shouldOpenConfirmDialog && (
          <ConfirmDialog
            className="z-index-1060"
            show={shouldOpenConfirmDialog}
            title="Thông báo"
            message={validateMessage}
            close="Đóng"
            onCloseClick={() => {
              setValidateMessage('');
              setShouldOpenConfirmDialog(false);
            }}
          />
        )}
      </div>
    </Row>
  );
}

export default Thuoc;

const ThaoTacDonThuoc = ({ donThuocInfo, getDanhSachDonThuoc, handleSelectPhieu, allowOrder = true }: {
  getDanhSachDonThuoc: () => void;
  donThuocInfo: any;
  handleSelectPhieu: (id: number | string) => void;
  allowOrder?: boolean
}) => {
  const { benhNhanHanhChinh, statusChangedEventFunc } = usePhanHeNoiTruContext();

  const [guiDonThuoc, setGuiDonThuoc] = useState<boolean>();
  const [openDonThuocDialog, setOpenDonThuocDialog] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [keyOpenPhieuIn, setKeyOpenPhieuIn] = useState<string>('');
  const [isUpdateWorkflow, setIsUpdateWorkflow] = useState(false);

  const isXuatKho = [
    WORKFLOW_MEDICAL_ITEM_STATUS_CODE.CHO_XUAT_KHO,
    WORKFLOW_MEDICAL_ITEM_STATUS_CODE.DA_XUAT_KHO,
  ].includes(donThuocInfo?.statusCode);

  const onDeleteDonThuoc = async () => {
    try {
      const response = await deleteDonThuoc(donThuocInfo.id);
      if (CODE.SUCCESS === response.code) {
        toast.success(RESPONSE_MESSAGE.DELETE.SUCCESS);
        setOpenConfirmDialog(false);
        getDanhSachDonThuoc();
        statusChangedEventFunc?.();
      } else {
        let errorMessage = response?.data?.[0]?.errorMessage || RESPONSE_MESSAGE.ERROR;
        toast.warn(errorMessage);
      }
    } catch (error) {
      console.error(error);
      toast.error(RESPONSE_MESSAGE.ERROR);
    }
  };

  const handlePressKeyShortcuts = (e: any) => {
    switch (e.key) {
      case KEY.F3:
        e.preventDefault();
        setKeyOpenPhieuIn('F3');
        break;
      default:
        return;
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handlePressKeyShortcuts);
    return () => {
      window.removeEventListener('keydown', handlePressKeyShortcuts);
    };
  }, []);

  useEffect(() => {
    setGuiDonThuoc(donThuocInfo?.statusCode === WORKFLOW_MEDICAL_ITEM_STATUS_CODE.GUI_DON);
  }, [donThuocInfo?.statusCode]);

  const PrintButton = () => {
    return (
      <ButtonIn<IInPhieuChiDinhThuocParams>
        fetchExport={printPhieuChiDinhThuoc}
        params={{
          fileType: 'pdf',
          patientId: benhNhanHanhChinh?.patientId,
          medicalItemGroupId: donThuocInfo.id,
          visitId: benhNhanHanhChinh?.visitId,
          type: parseInt(ORDER_TYPE_ID.THUOC),
        }}
        label="In đơn thuốc (F3)"
        className="btn-fill"
        keyOpenPhieuIn={keyOpenPhieuIn}
        setKeyOpenPhieuIn={setKeyOpenPhieuIn}
        keyBtn={KEY.F3}
      />
    );
  };

  const WorkFlowButton = () => {
    return (
      <WfButton
        tracker={WfConstTrackerClinical.MEDICAL_ITEMS}
        objectId={donThuocInfo?.id}
        prefixFunction={(statusCode: string, callbackFn: () => any, cancel?: () => void) => {
          if (WORKFLOW_MEDICAL_ITEM_STATUS_CODE.CHUA_GUI_DON === statusCode) {
            onGuiDonThuoc(callbackFn, cancel)
            return;
          }

          onHuyGuiDonThuoc(callbackFn, cancel);
        }}
        additionalFunc={(status: any) => {
          onUpdateWorkflowStatus(status);
        }}
        forceRender={isUpdateWorkflow}
      ></WfButton>
    );
  };

  const onGuiDonThuoc = async (callbackFn: () => void, cancel?: () => void) => {
    try {
      const { data } = await updateKeThuoc({
        ...donThuocInfo,
        encounterId: donThuocInfo?.encounterId,
        orderTypeId: parseInt(ORDER_TYPE_ID.THUOC),
        lstMedicalItemOrder: donThuocInfo?.lstMedicalItemOrderRes,
        formCode: REQUEST_FROM.DIEU_TRI,
        medicalItemTypeCode: REQUEST_TYPE.THUOC,
        visitObjectTypeCode: benhNhanHanhChinh?.visitObjectTypeCode
      });
      if (CODE.SUCCESS === data?.code) {
        toast.success('Gửi đơn thuốc thành công');
        callbackFn();
      } else {
        toast.error(getErrorMessage({ data }));
        cancel?.();
      }
    } catch (error) {
      console.error(error);
      toast.error(RESPONSE_MESSAGE.ERROR);
      cancel?.();
    }
  };

  const onHuyGuiDonThuoc = async (callbackFn: () => void, cancel?: () => void) => {
    try {
      const { code, data } = await huyGuiDonThuoc(donThuocInfo?.id);
      if (CODE.SUCCESS === code) {
        toast.success('Huỷ gửi đơn thuốc thành công');
        callbackFn();
      } else {
        toast.error(getErrorMessage({ code, data }));
        cancel?.();
      }
    } catch (error) {
      console.error(error);
      toast.error(RESPONSE_MESSAGE.ERROR);
      cancel?.();
    }
  };

  const onUpdateWorkflowStatus = (workflowStatus: string) => {
    setGuiDonThuoc(workflowStatus === WORKFLOW_MEDICAL_ITEM_STATUS_CODE.GUI_DON);
    handleSelectPhieu(donThuocInfo?.id);
  };

  if (!donThuocInfo?.id) return <div className="bg-white spaces min-h-50"></div>;

  if (isXuatKho) return <div className="d-flex gap-3 bg-white p-2">{PrintButton()}</div>;

  return (
		<div className="d-flex gap-2 justify-content-start p-2 bg-white">
			{guiDonThuoc ? (
				<>
					{PrintButton()}
          {donThuocInfo?.isAllowModify && allowOrder && WorkFlowButton()}
				</>
			) : (
				<>
					{donThuocInfo?.isAllowModify &&
						![WORKFLOW_MEDICAL_ITEM_STATUS_CODE.DANG_TONG_HOP].includes(
							donThuocInfo?.statusCode
              ) && allowOrder && (
							<>
								<Button
									onClick={() => setOpenDonThuocDialog(true)}
								>
									Sửa đơn thuốc
								</Button>
								{WorkFlowButton()}
								<Button
									className="btn-danger"
									onClick={() => setOpenConfirmDialog(true)}
								>
									Xóa đơn thuốc
								</Button>
							</>
						)}
				</>
			)}

			{openDonThuocDialog && (
				<FormChiDinhThuoc
					open={openDonThuocDialog}
					onClose={() => {
						setOpenDonThuocDialog(false);
					}}
					itemEdit={donThuocInfo}
					callbackFunc={() => {
						setOpenDonThuocDialog(false);
						setIsUpdateWorkflow(!isUpdateWorkflow);
						handleSelectPhieu(donThuocInfo?.id);
					}}
				/>
			)}

			{openConfirmDialog && (
				<ConfirmDialog
					className="z-index-1060"
					show={openConfirmDialog}
					title="Thông báo"
					message="Bạn có chắc chắn muốn xóa đơn thuốc này không ?"
					yes="Xác nhận"
					close="Đóng"
					onCloseClick={() => {
						setOpenConfirmDialog(false);
					}}
					onYesClick={onDeleteDonThuoc}
				/>
			)}
		</div>
  );
};